import {DateTime} from 'luxon';
import {TimeEntryFilterTimeFrame} from '@/services/api/nswag/stapiclient_generated';

export default class TimeFrame {
  From: DateTime;

  get IsoFrom(){
    return this.From.toFormat('yyyy-MM-dd');
  }

  To: DateTime;

  get IsoTo(){
    return this.To.toFormat('yyyy-MM-dd');
  }

  Name: TimeEntryFilterTimeFrame;
  Label: string;

  constructor(from: DateTime, to: DateTime, name: TimeEntryFilterTimeFrame, label: string) {
    this.From = from;
    this.To = to;
    this.Name = name;
    this.Label = label;
  }
}
